import * as React from 'react';
import { useState, useEffect } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ResearchSearchResult from './ResearchSearchResult';
import { Location } from 'types/location.type';
import { WithStyles } from '@mui/styles';
import styles from '../styles';

interface GoogleResearchSectionProps {
    location: Partial<Location>;
    classes: WithStyles<typeof styles>['classes'];
    searchTerms: Array<
        | { term: string; site?: string; displayTitle?: string; addressAsCityOnly?: boolean }
        | { term?: string; site: string; displayTitle?: string; addressAsCityOnly?: boolean }
    >;
}

export const GoogleResearchSection: React.FC<GoogleResearchSectionProps> = ({ location, classes, searchTerms }) => {
    const [expanded, setExpanded] = useState<boolean | string>(false);

    useEffect(() => {
        setExpanded(false);
    }, [location.id]);

    const handleChange = (panel: string) => (event: any, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Grid className={classes.margin}>
            {searchTerms.map((searchTerm) => {
                const identifier = searchTerm.term || searchTerm.site;
                return (
                    <Accordion
                        style={{ width: '600px' }}
                        expanded={expanded === identifier}
                        // Typescript doesn't seem to interpret the Props interface definition above to understand that at least term or site will be defined
                        // @ts-ignore
                        onChange={handleChange(identifier)}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id={`${searchTerm.term}Research-header`}
                        >
                            <Typography className={classes.heading}>
                                {searchTerm.displayTitle ||
                                    `${
                                        (searchTerm.term &&
                                            `${searchTerm.term.toUpperCase().charAt(0)}${searchTerm.term.slice(1)}`) ||
                                        (searchTerm.site &&
                                            `${searchTerm.site.toUpperCase().charAt(0)}${searchTerm.site.slice(1)}`)
                                    } Research`}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ResearchSearchResult
                                locationName={location.locationName}
                                // Some research functions need only the city, not the address.
                                locationAddress={
                                    searchTerm.addressAsCityOnly
                                        ? location.city
                                        : location.formattedAddress || location.city
                                }
                                researchTerm={searchTerm.term}
                                researchSite={searchTerm.site}
                                isOpen={expanded === identifier}
                            />
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </Grid>
    );
};

export default GoogleResearchSection;
